/* eslint-disable react/prop-types */

import React, { forwardRef } from 'react';
import { Rect } from 'react-konva';

// eslint-disable-next-line react/prop-types, react/display-name
const RectangleShape = forwardRef((props, ref) => {
  return (
    <React.Fragment>
    <Rect
        ref={ref}
        {...props}
    />
    </React.Fragment>
  );
});
export default React.memo(RectangleShape);
